import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { SectionCTA } from './SectionCTA';
import { afterItems, beforeItems } from '../data/content';
export function BeforeAfter() {
  return <section className="w-full bg-white px-5 py-16 md:py-24" data-id="element-38" data-mp="3ofhxvfzy3nzu">
      <div className="mx-auto max-w-6xl" data-id="element-39" data-mp="3sgbjg2px0qpk">
        <SectionHeading eyebrow="Before vs. With the Roadmap™" title="From Scattered Intervention Ideas to a More Organized Planning Process" data-id="element-40" data-mp="3sjftvhtz4ioo" />

        <div className="mt-12 grid gap-6 md:grid-cols-2 md:gap-8" data-id="element-41" data-mp="3jhgawjzef4j3">
          <div className="rounded-3xl bg-red-50 p-5 ring-2 ring-red-200 sm:p-7" data-id="element-42" data-mp="34sadn1k4fodu">
            <div className="flex items-center gap-3" data-id="element-43" data-mp="39qlqzm9mkh0t">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-red-600 text-white" data-id="element-44" data-mp="39rem1pz81i34">
                <XIcon className="h-6 w-6" strokeWidth={3} aria-hidden="true" data-id="element-45" data-mp="2vt6ww48ffl2i" />
              </span>
              <h3 className="text-2xl font-extrabold uppercase text-red-700" data-id="element-46" data-mp="30s9qmsiyi4v6">Before</h3>
            </div>
            <ul className="mt-6 space-y-3" data-id="element-47" data-mp="x6n1y7nakxmm">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-white p-4" data-id="element-48" data-mp="t2p03p6l18pv">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" strokeWidth={3} aria-hidden="true" data-id="element-49" data-mp="171yimvi9gex0" />
                  <span className="text-base leading-relaxed text-gray-800" data-id="element-50" data-mp="121k7v5p9yqva">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl bg-mint-50 p-5 ring-2 ring-mint-400 sm:p-7" data-id="element-51" data-mp="9g0vgksxrleq">
            <div className="flex items-center gap-3" data-id="element-52" data-mp="o4dvbsv59oei">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-mint-600 text-white" data-id="element-53" data-mp="o5yn5aq2qt8o">
                <CheckIcon className="h-6 w-6" strokeWidth={3} aria-hidden="true" data-id="element-54" data-mp="jbc9t20fmqly" />
              </span>
              <h3 className="text-2xl font-extrabold uppercase text-mint-700" data-id="element-55" data-mp="3mtvunjgs6u6q">With the Roadmap™</h3>
            </div>
            <ul className="mt-6 space-y-3" data-id="element-56" data-mp="1qr98tr2844ha">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-white p-4" data-id="element-57" data-mp="1vpkio1siqezi">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-mint-600" strokeWidth={3} aria-hidden="true" data-id="element-58" data-mp="20gizd2hf5f3a" />
                  <span className="text-base font-medium leading-relaxed text-brand-950" data-id="element-59" data-mp="24inrtxw4s5oc">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-12 max-w-2xl rounded-3xl bg-brand-700 p-7 text-center" data-id="element-60" data-mp="1cqyhyo0wypw4">
          <p className="text-2xl font-extrabold text-cta" data-id="element-61" data-mp="1cst05uksw3wi">The Difference?</p>
          <p className="mt-3 text-lg leading-relaxed text-white" data-id="element-62" data-mp="1gr8mdw92588v">
            You're no longer relying on a scattered collection of activities to guide your planning. You're using an
            organized process to connect clinical information with purposeful intervention decisions.
          </p>
        </div>

        <SectionCTA label="I Want the Complete Treatment Roadmap™" data-id="element-63" data-mp="2x8mmc8t3gv0e" />
      </div>
    </section>;
}